import React from 'react';
import Modal from 'shared/components/modal';
import browserHistory from 'shared/history';
import {CURRENT_FOUR_YEAR_NOT_TRANSFERRING} from '../../views/public/utils/utils';

interface Props {
  handleClose?: () => void;
}

const CantEarnModal = ({handleClose}: Props) => {
  const closeModal = () => {
    window.sessionStorage.removeItem(CURRENT_FOUR_YEAR_NOT_TRANSFERRING);
    if (handleClose) {
      handleClose();
    } else {
      browserHistory.push(window.location.pathname.split('/cant-earn')[0]);
    }
  };

  const title = 'Important Information About Your Eligibility';

  const text =
    'You indicated that you are only looking to earn for your current college. At this time Raise Me only supports ' +
    'students who intend to transfer to other 4-year universities. Explore our college search page to find other ' +
    '4-year universities';

  return (
    <Modal show className="welcome-modal" onClose={closeModal}>
      <Modal.TextHeader onClose={closeModal}>{title}</Modal.TextHeader>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer
        primaryButton={{
          onClick: closeModal,
          width: 85,
          text: 'Close',
        }}
      />
    </Modal>
  );
};

export default CantEarnModal;
